<template>
  <v-menu>
    <template #activator="{ on: menuListeners, attrs }">
      <v-tooltip bottom :disabled="!useTooltip">
        <template #activator="{ on: tooltipListeners }">
          <slot
            name="button"
            v-bind="{
              loadingState: exporting,
              disabedState: disabled,
              on: { ...menuListeners, ...tooltipListeners },
              attrs
            }"
          >
            <v-btn
              :loading="exporting"
              :disabled="disabled"
              v-bind="[attrs, buttonProps]"
              v-on="{ ...menuListeners, ...tooltipListeners }"
            >
              <v-icon :small="buttonProps.small" class="mr-2"
                ><slot name="icon">$iconDownload</slot></v-icon
              >
              <slot>{{
                $t("common:button.downloadCsv", "Download as csv")
              }}</slot>
            </v-btn>
          </slot>
        </template>
        <span style="max-width: 25rem">
          <slot name="tooltip">
            {{
              $t(
                "common:downloadCsv.tooltip",
                "Limited to 2 000 records. Please use filters to narrow down the search and give time for download to finish"
              )
            }}
          </slot>
        </span>
      </v-tooltip>
    </template>
    <v-list>
      <slot
        name="items"
        v-bind="{ setLoading, startExport, loading: exporting }"
      >
        <v-list-item @click="startExport('xlsx')">
          <v-list-item-title>{{
            $t("common:button.exportExcel", "Excel / XLSX format")
          }}</v-list-item-title>
        </v-list-item>
        <v-list-item @click="startExport('csv')">
          <v-list-item-title>{{
            $t("common:button.exportCsv", "CSV format")
          }}</v-list-item-title>
        </v-list-item>
        <slot name="append:items" v-bind="{ setLoading, loading: exporting }" />
      </slot>
    </v-list>
  </v-menu>
</template>
<script>
import { defineComponent, ref, getCurrentInstance } from "vue";
import { useExportFile } from "@composables/export_file";

export default defineComponent({
  name: "AppExportFile",
  props: {
    prepareFunction: {
      type: Function,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    useTooltip: {
      type: Boolean,
      default: false
    },
    buttonProps: {
      type: Object,
      default: () => ({
        color: "edit",
        large: true,
        small: false,
        text: true
      })
    }
  },
  setup(props) {
    const instance = getCurrentInstance().proxy;
    const { exportFile } = useExportFile();

    const exporting = ref(false);
    async function startExport(exportFileType) {
      try {
        exporting.value = true;
        const response = await props.prepareFunction();
        if (!response) {
          exporting.value = false;
          return;
        }
        const { keyMap, items, filename } = response;
        await exportFile({
          keyMap,
          items,
          exportFileType,
          filename
        });
      } catch (error) {
        instance.$root.$snackbarServerError(error, { level: "error" });
      } finally {
        exporting.value = false;
      }
    }

    function setLoading(v) {
      exporting.value = v;
    }

    return { startExport, setLoading, exporting };
  }
});
</script>
